//styles
import {
  AssistanceSection,
  AssistanceInner,
  AssistanceTitle,
  AssistanceGrid,
  AssistanceCard,
  AssistanceCardTitle,
  AssistanceCardText,
} from './NeedAssistance.styles';

export function NeedAssistance({ content }) {
  return (
    <AssistanceSection>
      <AssistanceInner>
        <AssistanceTitle>{content.title}</AssistanceTitle>
        <AssistanceGrid>
          <AssistanceCard>
            <AssistanceCardTitle>
              {content.cards.haul_with.title}
            </AssistanceCardTitle>
            <AssistanceCardText>
              {content.cards.haul_with.email}
            </AssistanceCardText>
            {content.cards.haul_with.phone && (
              <AssistanceCardText>
                {content.cards.haul_with.phone}
              </AssistanceCardText>
            )}
          </AssistanceCard>
          <AssistanceCard>
            <AssistanceCardTitle>
              {content.cards.haul_for.title}
            </AssistanceCardTitle>
            <AssistanceCardText>
              {content.cards.haul_for.email}
            </AssistanceCardText>
            {content.cards.haul_for.phone && (
              <AssistanceCardText>
                {content.cards.haul_for.phone}
              </AssistanceCardText>
            )}
          </AssistanceCard>
        </AssistanceGrid>
      </AssistanceInner>
    </AssistanceSection>
  );
}
